import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2016Status: 'idle',
    startProcess2016Error: undefined as any,
    loadUserParamsProcess2016Status: 'idle',
    loadUserParamsProcess2016Error: undefined as any,

    process2016List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2016 = createAsyncThunk('process2016Slice/startProcess2016', async ({ process2016 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2016/`,
        prepareData(process2016),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2016Status } = getState().process2016Slice
        return startProcess2016Status !== 'pending'
    }
})

export const loadUserParamsProcess2016 = createAsyncThunk('process2016Slice/loadUserParamsProcess2016', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2016/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2016Status } = getState().process2016Slice
        return loadUserParamsProcess2016Status !== 'pending'
    }
})

const Process2016Slice = createSlice({
    name: 'process2016Slice',
    initialState,
    reducers: {
        resetstartProcess2016: (state) => {
            state.job = undefined
            state.startProcess2016Error = undefined
        },
        resetstartProcess2016Error: (state) => {
            state.startProcess2016Error = undefined
        },
        resetloadUserParamsProcess2016: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2016Error = undefined
        },
        resetloadUserParamsProcess2016Error: (state) => {
            state.loadUserParamsProcess2016Error = undefined
        },
        removeFromProcess2016ListById: (state, action) => {
            state.process2016List = state.process2016List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2016ListByIds: (state, action) => {
            state.process2016List = state.process2016List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2016List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2016Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2016List = []
            state.startProcess2016Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2016.pending, (state) => {
            state.startProcess2016Status = 'pending'
            state.startProcess2016Error = undefined
        })
        builder.addCase(startProcess2016.fulfilled, (state, action) => {
            state.startProcess2016Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2016.rejected, (state, action) => {
            state.startProcess2016Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2016Error = action.error.message
            } else {
                state.startProcess2016Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2016.pending, (state) => {
            state.loadUserParamsProcess2016Status = 'pending'
            state.loadUserParamsProcess2016Error = undefined
        })
        builder.addCase(loadUserParamsProcess2016.fulfilled, (state, action) => {
            state.loadUserParamsProcess2016Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2016.rejected, (state, action) => {
            state.loadUserParamsProcess2016Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2016Error = action.error.message
            } else {
                state.loadUserParamsProcess2016Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2016,
    resetstartProcess2016Error,
    resetloadUserParamsProcess2016,
    resetloadUserParamsProcess2016Error,
    removeFromProcess2016ListById,
    removeFromProcess2016ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2016Slice.actions
export default Process2016Slice.reducer
